module.exports = __webpack_public_path__ + "img/bm-yandex-sat.8d3714e3.png";